// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1Fbim","item":"PaymentsMobile_item__1pH3Y","label":"PaymentsMobile_label__3Cbpc","amount":"PaymentsMobile_amount__VgwQZ"};